import { updateOrAddManyColumnOptionStates, updateOrAddManyColumnTemplates } from "../helpers";
export const applyGroupingOnColumnsReducer = (state, action) => {
    if (!action?.payload) {
        return;
    }
    action.payload.forEach((c) => {
        if (c.rowGroup && !c.hide) {
            c.hide = true;
        }
    });
    const newColumnOptions = updateOrAddManyColumnOptionStates(state, action.payload);
    if (newColumnOptions) {
        updateOrAddManyColumnTemplates(state, newColumnOptions);
    }
};
